// src/services/buyerApi.js
import { api } from "./apiServices";

/**
 * Fetches comprehensive details for a specific buyer.
 * Corresponds to GET /admin/buyers/{buyer_id}/view
 * @param {string|number} buyerId - The ID of the buyer to fetch.
 * @returns {Promise<Object>} A promise that resolves to the buyer details.
 */
export const getBuyerDetails = async (buyerId) => {
  try {
    const response = await api.get(`/admin/buyer/${buyerId}/view`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching details for buyer ${buyerId}:`, error);
    throw error;
  }
};

/**
 * Fetches the buyer's ENTIRE WhatsApp conversation (all outbound + inbound messages,
 * including unsolicited ones), ordered chronologically.
 * Corresponds to GET /admin/buyer/{buyer_id}/conversations
 * @param {string|number} buyerId - The ID of the buyer.
 * @returns {Promise<Object>} A promise that resolves to { buyer_id, phone, messages: [...] }.
 */
export const getBuyerConversation = async (buyerId) => {
  if (!buyerId) throw new Error("Buyer ID is required.");
  try {
    const response = await api.get(`/admin/buyer/${buyerId}/conversations`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching conversation for buyer ${buyerId}:`, error);
    throw error;
  }
};
